export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#18B7B4',
    contrastText: '#FFFFFF',
    light: '#F1FAFE',
  },
  secondary: {
    main: '#54575A',
    contrastText: '#002855',
  },
  text: {
    primary: '#111111',
    light: 'rgba(71, 86, 112, 0.8)',
    secondary: '#5E6C77',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    price: '#004485',
    dark: '#002060'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#26364D',
    primary: '#18B7B4',
    paper: '#FFF',
    light: '#EDEDED',
    dark: '#2D3031',
    default: '#FFF',
    header: '#26364D',
    footer: '#374E6F',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#54575A',
    tableSubhead: '#F7F7F7',
    arrow: '#18B7B4',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
    thumb: '#157E9E'
  },
  verticalBar: {
    used: '#18B7B4',
    unused: '#D0F0F0',
    unlimited: '#C0C0C0',
  }
};
